import React, { useState } from "react";
import { Skeleton } from "antd";
import { Route, Switch } from "react-router-dom";

import Proposals from "./components/Proposals/Proposals";
import Proposal from "./components/Proposals/components/Proposal/Proposal";
import Summary from "./components/Summary/Summary";
import GptSolutions from "./components/GptSolutions/GptSolutions";

import {
  buildPNRSummaryUri,
  buildPNRProposalsUri,
  buildPNRProposalUri,
  buildPNRGptSolutionsUri,
} from "utils/routes";

const NavReprogram = ({
  isLoading,
  summaryInfo,
  currentReporting,
  proposals,
}) => {
  const [isSettingsModalVisible, setIsSettingsModalVisible] = useState(false);

  return (
    <Switch>
      <Route path={buildPNRSummaryUri()}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Summary
            personalInfo={summaryInfo.personalInfo}
            currentReporting={currentReporting}
            proposals={proposals}
            setIsSettingsModalVisible={setIsSettingsModalVisible}
          />
        )}
      </Route>
      <Route path={buildPNRProposalUri()}>
        <Proposal />
      </Route>
      <Route path={buildPNRProposalsUri()}>
        <Proposals
          insurancesInfo={summaryInfo.insuranceSummary}
          currentReporting={currentReporting}
          isSettingsModalVisible={isSettingsModalVisible}
          setIsSettingsModalVisible={setIsSettingsModalVisible}
          adviseeDetails={summaryInfo.personalInfo}
        />
      </Route>
      <Route path={buildPNRGptSolutionsUri()}>
        <GptSolutions
          insurancesInfo={summaryInfo.insuranceSummary}
          personalInfo={summaryInfo.personalInfo}
          currentReporting={currentReporting}
          proposals={proposals}
          setIsSettingsModalVisible={setIsSettingsModalVisible}
        />
      </Route>
    </Switch>
  );
};

export default NavReprogram;
